// import React, { Component } from "react";
import React from "react";
import "./Review.css";
import Slider from "react-slick";
import profile from "../../Images/profile.png";
import ashish_thakur from "../../Images/ashish_thakur.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Review = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
  const formValues = [
    {
      id: 2,
      img: profile,
      title: "Maninder Gabri",
      star: "⭐⭐⭐⭐⭐",
      description:
        "A very nice resort it's under construction but the restaurant is open and rooms are available, very nice and tasty food served here. Located near Shen international school. Near kandra toll plaza. parking space available. Owner and staff is very good they are very polite.",
    },
    {
      id: 1,
      img: ashish_thakur,
      title: "Ashish Thakur",
      star: "⭐⭐⭐⭐⭐",
      description:
        "The total experience was quite pleasant. The ambiance, service, flavour, and quality of the cuisine are excellent. It's worth a visit.",
    },
    {
      id: 3,
      img: profile,
      title: "Lalan Choudhary",
      star: "⭐⭐⭐⭐⭐",
      description:
        "Natural and green environment , away from rush of township , neat and clean campus and prompt service of delicious food .",
    },
    {
      id: 4,
      img: profile,
      title: "Prabhat Kumar",
      star: "⭐⭐⭐⭐⭐",
      description:
        "Nice ambience, nice location , nice food",
    }
  ];
  const handleLoad = () => {
    const carouselDivs = document.querySelectorAll(".carousel-slide");

    carouselDivs.forEach((element) => {
      element.style.removeProperty("display");
    });
  };
  return (
    <div className="container">
      <p className="container-title">Customer Reviews</p>
      <Slider {...settings}>
        {formValues.map((item, index) => {
          return (
            <div className="carousel-slide" key={item.id} onLoad={handleLoad}>
              {/* <img src={item.img} alt={`Reviewer number ${index}`} /> */}
              <h3 className="item-title">{item.title}</h3>
              <h3 className="item-star">{item.star}</h3>
              <h6 className="item-description">{item.description}</h6>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default Review;
